export const aboutData = {
  hero: {
    title: '关于韩漫在线',
    subtitle: '让每一位漫画爱好者都能享受免费、优质的韩漫阅读体验',
    description: '韩漫在线成立于2023年，作为一家专注韩国漫画的在线阅读平台，我们致力于为中文读者提供最新、最全、最高清的韩漫资源。我们的团队由漫画爱好者和技术专家组成，热爱漫画、懂技术，更懂读者的需求。',
  },
  mission: {
    title: '我们的使命',
    content: '打破语言和地域的界限，让每一位中文读者都能随时随地享受韩国漫画的魅力。我们相信，好的故事不需要门槛，每个人都有权利享受阅读的乐趣。',
  },
  values: [
    {
      title: '免费至上',
      description: '我们坚持所有漫画内容完全免费，让更多读者能够无负担地享受阅读。',
      icon: 'ri-heart-line',
    },
    {
      title: '品质优先',
      description: '高清画质、精准翻译、及时更新，每一个环节都追求极致品质。',
      icon: 'ri-star-line',
    },
    {
      title: '用户为本',
      description: '倾听读者声音，不断优化阅读体验，打造最懂用户的漫画平台。',
      icon: 'ri-user-smile-line',
    },
    {
      title: '持续创新',
      description: '不断探索新技术，用最好的产品体验服务每一位漫画爱好者。',
      icon: 'ri-lightbulb-line',
    },
  ],
  stats: [
    { label: '漫画作品', value: '1500+', icon: 'ri-book-open-line' },
    { label: '累计读者', value: '500万+', icon: 'ri-user-heart-line' },
    { label: '每日更新', value: '50+', icon: 'ri-refresh-line' },
    { label: '用户好评', value: '98%', icon: 'ri-thumb-up-line' },
  ],
  timeline: [
    { year: '2023年3月', title: '平台正式上线', description: '韩漫在线网站正式发布，首批上线200部精选韩漫。' },
    { year: '2023年8月', title: '用户突破10万', description: '凭借优质内容和良好口碑，注册用户快速增长突破10万。' },
    { year: '2024年1月', title: '移动端优化', description: '全面优化移动端阅读体验，支持手机和Pad无缝阅读。' },
    { year: '2024年6月', title: '内容突破1000部', description: '平台漫画资源突破1000部，覆盖所有主流韩漫类型。' },
    { year: '2025年1月', title: '用户突破500万', description: '累计服务读者超过500万，成为中文韩漫阅读首选平台。' },
    { year: '2025年12月', title: '全面技术升级', description: '推出全新阅读引擎，加载速度提升300%，画质全面升级。' },
  ],
  contact: {
    title: '联系我们',
    description: '有任何问题、建议或合作意向？我们非常乐意听取您的声音。',
    email: 'hello@zaixinjiaju.com',
    wechat: '韩漫在线官方',
    weibo: '@韩漫在线',
    qq: '1234567890',
    workingHours: '工作日 9:00 - 18:00',
  },
  business: {
    title: '商务合作',
    description: '韩漫在线欢迎各类商业合作洽谈，包括但不限于广告投放、内容合作、品牌联名、IP授权等。我们拥有庞大的韩漫读者群体，期待与您携手共赢。',
    email: 'hello@zaixinjiaju.com',
    wechat: '韩漫在线商务',
    phone: '+86 400-888-9999',
    items: [
      { title: '广告投放', description: '首页Banner、分类页推荐位、文章页插屏等多种广告形式，精准触达漫画爱好者群体。', icon: 'ri-advertisement-line' },
      { title: '内容合作', description: '原创漫画投稿、漫画翻译合作、版权引进等内容的深度合作。', icon: 'ri-file-copy-line' },
      { title: '品牌联名', description: '与品牌联合推出限定活动、周边产品、主题展览等创意合作形式。', icon: 'ri-hand-heart-line' },
      { title: 'IP授权', description: '平台热门漫画IP的动漫改编、游戏改编、影视改编等授权合作。', icon: 'ri-shake-hands-line' },
    ],
  },
  faq: [
    {
      question: '韩漫在线是否完全免费？是否需要注册？',
      answer: '是的，韩漫在线所有漫画内容完全免费，无需注册即可在线阅读。我们致力于为所有漫画爱好者提供优质的免费阅读体验。如果您想收藏漫画或获得个性化推荐，可以选择免费注册账号。',
    },
    {
      question: '漫画更新频率如何？翻译质量怎么样？',
      answer: '我们保持每日更新的频率，热门漫画通常在原作更新后24小时内完成翻译和上线。我们的翻译团队由专业韩语翻译人员组成，确保翻译准确、流畅，同时保留原作的语言风格和文化韵味。',
    },
    {
      question: '支持哪些设备阅读？需要下载APP吗？',
      answer: '韩漫在线采用响应式设计，完美适配手机、平板和电脑等各类设备，无需下载任何APP。只要你有浏览器和网络，就能随时随地流畅阅读。同时我们也在开发原生APP，敬请期待。',
    },
    {
      question: '如何进行版权投诉或内容申诉？',
      answer: '韩漫在线高度重视版权保护。如果您是版权方或原作者，认为平台上的内容侵犯了您的权益，请通过 hello@zaixinjiaju.com 与我们联系，我们会在48小时内处理您的申诉。',
    },
    {
      question: '可以投稿自己的漫画作品吗？',
      answer: '当然可以！我们非常欢迎原创漫画作者投稿。请将作品简介和样张发送至 hello@zaixinjiaju.com，我们的编辑团队会在7个工作日内回复。对于优质原创内容，我们还提供首页推荐和流量扶持。',
    },
  ],
  seo: {
    title: '关于我们_韩漫在线 - 韩国漫画免费阅读平台',
    description: '了解韩漫在线 - 韩国漫画免费阅读平台，成立于2023年，专注为中文读者提供最新、最全、最高清的韩漫资源，已累计服务超过500万读者。',
    keywords: '韩漫在线,关于我们,韩国漫画,免费漫画,在线漫画',
  },
};